<ng-container *ngIf="!renderUsingConfig">

  <div *ngIf="_state=='claimAdjudication' " class="card-summary-title card-summary-ribbon">

    <h3 class="prominent">
      <div class="flex flex-horiz-space-bw flex-vert-center">
        <div>
          <span>{{getDO(policyData)?.clmIntimationNum}}</span>&nbsp;
          <nz-tag *ngIf="getDO(policyData)?.eventTypeCd" [nzColor]="'#333'">
            {{(getDO(policyData)?.eventTypeCd | technicalTranslate) || '' }}</nz-tag>
          <nz-tag [nzColor]="'#2db7f5'">
            {{getDO(policyData)?.stageCd != null? (getDO(policyData)?.stageCd | technicalTranslate : 'claimStageCd') : 'New Registration' }}
          </nz-tag>
          <!-- <nz-tag [nzColor]="'#2db7f5'">{{getDO(policyData)?.stageCd}}</nz-tag> -->
          <nz-tag *ngIf="lastUpdatedUser || lastUpdatedDate" class="tag-right"><span>Last updated <span
                *ngIf="lastUpdatedUser" style="font-weight: 500;">by {{lastUpdatedUser}}, </span></span>
            <span *ngIf="lastUpdatedDate">on <span
                style="font-weight: 500;">{{lastUpdatedDate | date : appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR}}</span>
            </span>
          </nz-tag>


        </div>
        <div>
          <!-- Mark as favourite -->
          <button nz-button nzType="default" nzSize="small" class="m-r-5" (click)="freezeToggle()">
            <span *ngIf="caseIsFrozen">Un-</span>Freeze
          </button>
          <button *ngIf="appMetadataHandler.featureFlags.enableDataEntryMode" nz-button nzType="default" nzSize="small" class="m-r-5" (click)="enableDataEntryMode()">
            <span></span>Data Entry Mode
          </button>
          <a class="clickable col-white">
            <i *ngIf="isStarred" (click)="starThis()" nz-icon nzType="star" nzTheme="fill"></i>
            <i *ngIf="!isStarred" (click)="starThis()" nz-icon nzType="star" nzTheme="outline"></i>
          </a>
        </div>
      </div>
    </h3>

    <div class="card-summary-ribbon-grid card-summary-ribbon-grid-duo">

      <div>
        <div class="grid grid-3x p-b-10">
          <div *ngFor="let item of metaDataArray">
            <strong class="c-s-heading">{{item.description}}</strong>

            <span *ngIf="item.key !=='proposalNum' "> {{claimRibbonObj[item.key]?claimRibbonObj[item.key] : "-"}} </span>
            <span *ngIf="item.lookup"> {{ claimRibbonObj[item.key] | technicalTranslate : item.lookup }} </span>
            <nz-select nzShowSearch *ngIf="item.key =='proposalNum' && proposalDOs && proposalDOs.length > 0" class=""
              nzPlaceHolder="Choose" nzSize='small' (ngModelChange)="changeRibbonContains($event)"
              [(ngModel)]="selectPolNum">
              <nz-option *ngFor="let item of proposalDOs" [nzLabel]="item?.proposalNum" [nzValue]="item?.proposalNum">
              </nz-option>
            </nz-select>
          </div>
        </div>

        <div>
          <nz-tooltip nzTooltipTitle="3 done / 3 in progress / 4 to do" nzTooltipPlacement="bottom">
            <nz-progress nz-tooltip [nzPercent]="30" [nzSuccessPercent]="60" nzStatus="active"></nz-progress>
          </nz-tooltip>
        </div>
      </div>

      <div class="card-summary-ribbon-links">
        <h5>Actions</h5>
        <a (click)="activityPanel(1)"><i class="anticon anticon-profile"></i> Activity Timeline</a>
        <a (click)="workflowPanel(1)"><i class="anticon anticon-audit"></i> Workflow Audit</a>
        <a (click)="corresPanel(1)"><i class="anticon anticon-inbox"></i> Correspondence</a>
        <a (click)="policyPanel(1)" [class.anchor-is-disabled]='!selectedClient'><i
            class="anticon anticon-file-protect"></i> View Policy</a>
        <a (click)="profilePanel(1)" [class.anchor-is-disabled]='!selectedClient'><i class="anticon anticon-user"></i>
          View Profile</a>
      </div>
      <div class="card-summary-ribbon-links">
        <h5>Supporting</h5>
        <a *ngIf="!isNew" (click)="notesPanel(1)"><i class="anticon anticon-read"></i> Notes</a>
        <a (click)="documentOpenEmitTransation()"><i class="anticon anticon-paper-clip"></i> Documents</a>
        <a (click)="worksheetPanel(1)"><i class="anticon anticon-reconciliation"></i> Claim Worksheet</a>
        <a (click)="analyticsModal=true"><i class="anticon anticon-dot-chart"></i>
          Analyze</a>
      </div>
    </div>

    <ng-template #tasksTimelineTemplate>
      <nz-timeline class="p-20">
        <nz-timeline-item [nzDot]="timeWaitTemplate">
          Data Entry
          <small class="d-b">
            PAPER ENTRY assigned to Jane Doe
          </small>
        </nz-timeline-item>
        <nz-timeline-item nzColor="green">
          Policy initialisation
          <small class="d-b">15 Jan 2019 at 11:01 AM (15 minutes ago)</small>
        </nz-timeline-item>
      </nz-timeline>
    </ng-template>
    <ng-template #timeWaitTemplate>
      <i nz-icon nzType="clock-circle-o" style="font-size: 16px;"></i>
    </ng-template>

  </div>

  <div *ngIf="_state=='claimIntimation' " class="card-summary-title card-summary-ribbon">

    <h3 class="prominent">
      <div class="flex flex-horiz-space-bw flex-vert-center">
        <div>
          <span>{{getDO(policyData)?.clmIntimationNum}}</span>&nbsp;
          <nz-tag *ngIf="getDO(policyData)?.eventTypeCd" [nzColor]="'#333'">
            {{(getDO(policyData)?.eventTypeCd | technicalTranslate) || ''}}</nz-tag>
          <nz-tag [nzColor]="'#2db7f5'">
            {{getDO(policyData)?.stageCd != null? (getDO(policyData)?.stageCd | technicalTranslate) : 'New Intimation'}}
          </nz-tag>
          <!-- <nz-tag [nzColor]="'#2db7f5'">{{getDO(policyData)?.stageCd}}</nz-tag> -->
          <nz-tag *ngIf="lastUpdatedUser || lastUpdatedDate" class="tag-right"><span>Last updated <span
                *ngIf="lastUpdatedUser" style="font-weight: 500;">by {{lastUpdatedUser}}, </span></span>
            <span *ngIf="lastUpdatedDate">on <span
                style="font-weight: 500;">{{lastUpdatedDate | date : appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR}}</span>
            </span>
          </nz-tag>


        </div>
        <div>
          <!-- Mark as favourite -->
          <button nz-button nzType="default" nzSize="small" class="m-r-5" (click)="freezeToggle()">
            <span *ngIf="caseIsFrozen">Un-</span>Freeze
          </button>
          <a class="clickable col-white">
            <i *ngIf="isStarred" (click)="starThis()" nz-icon nzType="star" nzTheme="fill"></i>
            <i *ngIf="!isStarred" (click)="starThis()" nz-icon nzType="star" nzTheme="outline"></i>
          </a>
        </div>
      </div>
    </h3>

    <div class="card-summary-ribbon-grid card-summary-ribbon-grid-duo">

      <div>
        <div class="grid grid-3x p-b-10">
          <div *ngFor="let item of metaDataArray">
            <strong class="c-s-heading">{{item.description}}</strong>

            <span *ngIf="item.key !=='proposalNum' "> {{claimRibbonObj[item.key]?claimRibbonObj[item.key] : "-"}} </span>
            <nz-select nzShowSearch *ngIf="item.key =='proposalNum' && proposalDOs && proposalDOs.length > 0" class=""
              nzPlaceHolder="Choose" nzSize='small' (ngModelChange)="changeRibbonContains($event)"
              [(ngModel)]="selectPolNum">
              <nz-option *ngFor="let item of proposalDOs" [nzLabel]="item?.proposalNum" [nzValue]="item?.proposalNum">
              </nz-option>
            </nz-select>
          </div>
        </div>

        <div>
          <nz-tooltip nzTooltipTitle="3 done / 3 in progress / 4 to do" nzTooltipPlacement="bottom">
            <nz-progress nz-tooltip [nzPercent]="30" [nzSuccessPercent]="60" nzStatus="active"></nz-progress>
          </nz-tooltip>
        </div>
      </div>

      <div class="card-summary-ribbon-links">
        <h5>Actions</h5>
        <a (click)="activityPanel(1)"><i class="anticon anticon-profile"></i> Activity Timeline</a>
        <a (click)="workflowPanel(1)"><i class="anticon anticon-audit"></i> Workflow Audit</a>
        <a (click)="corresPanel(1)"><i class="anticon anticon-inbox"></i> Correspondence</a>
        <a (click)="policyPanel(1)" [class.anchor-is-disabled]='!selectedClient'><i
            class="anticon anticon-file-protect"></i> View Policy</a>
        <a (click)="profilePanel(1)" [class.anchor-is-disabled]='!selectedClient'><i class="anticon anticon-user"></i>
          View Profile</a>
      </div>
      <div class="card-summary-ribbon-links">
        <h5>Supporting</h5>
        <a *ngIf="!isNew" (click)="notesPanel(1)"><i class="anticon anticon-read"></i> Notes</a>
        <a (click)="documentOpenEmitTransation()"><i class="anticon anticon-paper-clip"></i> Documents</a>
        <a (click)="worksheetPanel(1)"><i class="anticon anticon-reconciliation"></i> Claim Worksheet</a>
        <a (click)="analyticsModal=true"><i class="anticon anticon-dot-chart"></i>
          Analyze</a>
      </div>
    </div>

    <ng-template #tasksTimelineTemplate>
      <nz-timeline class="p-20">
        <nz-timeline-item [nzDot]="timeWaitTemplate">
          Data Entry
          <small class="d-b">
            PAPER ENTRY assigned to Jane Doe
          </small>
        </nz-timeline-item>
        <nz-timeline-item nzColor="green">
          Policy initialisation
          <small class="d-b">15 Jan 2019 at 11:01 AM (15 minutes ago)</small>
        </nz-timeline-item>
      </nz-timeline>
    </ng-template>
    <ng-template #timeWaitTemplate>
      <i nz-icon nzType="clock-circle-o" style="font-size: 16px;"></i>
    </ng-template>

  </div>

  <div *ngIf="_state=='claimRegistration' " class="card-summary-title card-summary-ribbon">

    <h3 class="prominent">
      <div class="flex flex-horiz-space-bw flex-vert-center">
        <div>
          <span>{{getDO(policyData)?.claimNum}}</span>&nbsp;
          <nz-tag *ngIf="getDO(policyData)?.eventTypeCd" [nzColor]="'#333'">
            {{(getDO(policyData)?.eventTypeCd | technicalTranslate) || ''}}</nz-tag>
          <nz-tag [nzColor]="'#2db7f5'">
            {{getDO(policyData)?.stageCd != null? (getDO(policyData)?.stageCd | technicalTranslate) : 'New Registration' }}
          </nz-tag>
          <!-- <nz-tag [nzColor]="'#2db7f5'">{{getDO(policyData)?.stageCd}}</nz-tag> -->
          <nz-tag *ngIf="lastUpdatedUser || lastUpdatedDate" class="tag-right"><span>Last updated <span
                *ngIf="lastUpdatedUser" style="font-weight: 500;">by {{lastUpdatedUser}}, </span></span>
            <span *ngIf="lastUpdatedDate">on <span
                style="font-weight: 500;">{{lastUpdatedDate | date : appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR}}</span>
            </span>
          </nz-tag>


        </div>
        <div>
          <!-- Mark as favourite -->
          <button nz-button nzType="default" nzSize="small" class="m-r-5" (click)="freezeToggle()">
            <span *ngIf="caseIsFrozen">Un-</span>Freeze
          </button>
          <a class="clickable col-white">
            <i *ngIf="isStarred" (click)="starThis()" nz-icon nzType="star" nzTheme="fill"></i>
            <i *ngIf="!isStarred" (click)="starThis()" nz-icon nzType="star" nzTheme="outline"></i>
          </a>
        </div>
      </div>
    </h3>

    <div class="card-summary-ribbon-grid card-summary-ribbon-grid-duo">

      <div>
        <div class="grid grid-3x p-b-10">
          <div *ngFor="let item of metaDataArray">
            <strong class="c-s-heading">{{item.description}}</strong>

            <span *ngIf="item.key !=='proposalNum' "> {{claimRibbonObj[item.key]?claimRibbonObj[item.key] : "-"}} </span>
            <nz-select nzShowSearch *ngIf="item.key =='proposalNum' && proposalDOs && proposalDOs.length > 0" class=""
              nzPlaceHolder="Choose" nzSize='small' (ngModelChange)="changeRibbonContains($event)"
              [(ngModel)]="selectPolNum">
              <nz-option *ngFor="let item of proposalDOs" [nzLabel]="item?.proposalNum" [nzValue]="item?.proposalNum">
              </nz-option>
            </nz-select>
          </div>
        </div>

        <div>
          <nz-tooltip nzTooltipTitle="3 done / 3 in progress / 4 to do" nzTooltipPlacement="bottom">
            <nz-progress nz-tooltip [nzPercent]="30" [nzSuccessPercent]="60" nzStatus="active"></nz-progress>
          </nz-tooltip>
        </div>
      </div>

      <div class="card-summary-ribbon-links">
        <h5>Actions</h5>
        <a (click)="activityPanel(1)"><i class="anticon anticon-profile"></i> Activity Timeline</a>
        <a (click)="workflowPanel(1)"><i class="anticon anticon-audit"></i> Workflow Audit</a>
        <a (click)="corresPanel(1)"><i class="anticon anticon-inbox"></i> Correspondence</a>
        <a (click)="policyPanel(1)" [class.anchor-is-disabled]='!selectedClient'><i
            class="anticon anticon-file-protect"></i> View Policy</a>
        <a (click)="profilePanel(1)" [class.anchor-is-disabled]='!selectedClient'><i class="anticon anticon-user"></i>
          View Profile</a>
      </div>
      <div class="card-summary-ribbon-links">
        <h5>Supporting</h5>
        <a *ngIf="!isNew" (click)="notesPanel(1)"><i class="anticon anticon-read"></i> Notes</a>
        <a (click)="documentOpenEmitTransation()"><i class="anticon anticon-paper-clip"></i> Documents</a>
        <a (click)="worksheetPanel(1)"><i class="anticon anticon-reconciliation"></i> Claim Worksheet</a>
        <a (click)="analyticsModal=true"><i class="anticon anticon-dot-chart"></i>
          Analyze</a>
      </div>
    </div>

    <ng-template #tasksTimelineTemplate>
      <nz-timeline class="p-20">
        <nz-timeline-item [nzDot]="timeWaitTemplate">
          Data Entry
          <small class="d-b">
            PAPER ENTRY assigned to Jane Doe
          </small>
        </nz-timeline-item>
        <nz-timeline-item nzColor="green">
          Policy initialisation
          <small class="d-b">15 Jan 2019 at 11:01 AM (15 minutes ago)</small>
        </nz-timeline-item>
      </nz-timeline>
    </ng-template>
    <ng-template #timeWaitTemplate>
      <i nz-icon nzType="clock-circle-o" style="font-size: 16px;"></i>
    </ng-template>

  </div>

  <div *ngIf="_state=='claimInvestigation' " class="card-summary-title card-summary-ribbon">

    <h3 class="prominent">
      <div class="flex flex-horiz-space-bw flex-vert-center">
        <div>
          <span>{{getDO(policyData)?.clmIntimationNum}}</span>&nbsp;
          <nz-tag *ngIf="getDO(policyData)?.eventTypeCd" [nzColor]="'#333'">
            {{(getDO(policyData)?.eventTypeCd | technicalTranslate) || ''}}</nz-tag>
          <nz-tag [nzColor]="'#2db7f5'">
            {{getDO(policyData)?.stageCd != null? (getDO(policyData)?.stageCd | technicalTranslate) : 'New Registration' }}
          </nz-tag>
          <!-- <nz-tag [nzColor]="'#2db7f5'">{{getDO(policyData)?.stageCd}}</nz-tag> -->
          <nz-tag *ngIf="lastUpdatedUser || lastUpdatedDate" class="tag-right"><span>Last updated <span
                *ngIf="lastUpdatedUser" style="font-weight: 500;">by {{lastUpdatedUser}}, </span></span>
            <span *ngIf="lastUpdatedDate">on <span
                style="font-weight: 500;">{{lastUpdatedDate | date : appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR}}</span>
            </span>
          </nz-tag>


        </div>
        <div>
          <!-- Mark as favourite -->
          <button nz-button nzType="default" nzSize="small" class="m-r-5" (click)="freezeToggle()">
            <span *ngIf="caseIsFrozen">Un-</span>Freeze
          </button>
          <a class="clickable col-white">
            <i *ngIf="isStarred" (click)="starThis()" nz-icon nzType="star" nzTheme="fill"></i>
            <i *ngIf="!isStarred" (click)="starThis()" nz-icon nzType="star" nzTheme="outline"></i>
          </a>
        </div>
      </div>
    </h3>

    <div class="card-summary-ribbon-grid card-summary-ribbon-grid-duo">

      <div>
        <div class="grid grid-3x p-b-10">
          <div *ngFor="let item of metaDataArray">
            <strong class="c-s-heading">{{item.description}}</strong>

            <span *ngIf="item.key !=='proposalNum' "> {{claimRibbonObj[item.key]?claimRibbonObj[item.key] : "-"}} </span>
            <nz-select nzShowSearch *ngIf="item.key =='proposalNum' && proposalDOs && proposalDOs.length > 0" class=""
              nzPlaceHolder="Choose" nzSize='small' (ngModelChange)="changeRibbonContains($event)"
              [(ngModel)]="selectPolNum">
              <nz-option *ngFor="let item of proposalDOs" [nzLabel]="item?.proposalNum" [nzValue]="item?.proposalNum">
              </nz-option>
            </nz-select>
          </div>
        </div>

        <div>
          <nz-tooltip nzTooltipTitle="3 done / 3 in progress / 4 to do" nzTooltipPlacement="bottom">
            <nz-progress nz-tooltip [nzPercent]="30" [nzSuccessPercent]="60" nzStatus="active"></nz-progress>
          </nz-tooltip>
        </div>
      </div>

      <div class="card-summary-ribbon-links">
        <h5>Actions</h5>
        <a (click)="activityPanel(1)"><i class="anticon anticon-profile"></i> Activity Timeline</a>
        <a (click)="workflowPanel(1)"><i class="anticon anticon-audit"></i> Workflow Audit</a>
        <a (click)="corresPanel(1)"><i class="anticon anticon-inbox"></i> Correspondence</a>
        <a (click)="policyPanel(1)" [class.anchor-is-disabled]='!selectedClient'><i
            class="anticon anticon-file-protect"></i> View Policy</a>
        <a (click)="profilePanel(1)" [class.anchor-is-disabled]='!selectedClient'><i class="anticon anticon-user"></i>
          View Profile</a>
      </div>
      <div class="card-summary-ribbon-links">
        <h5>Supporting</h5>
        <a *ngIf="!isNew" (click)="notesPanel(1)"><i class="anticon anticon-read"></i> Notes</a>
        <a (click)="documentOpenEmitTransation()"><i class="anticon anticon-paper-clip"></i> Documents</a>
        <a (click)="worksheetPanel(1)"><i class="anticon anticon-reconciliation"></i> Claim Worksheet</a>
        <a (click)="analyticsModal=true"><i class="anticon anticon-dot-chart"></i>
          Analyze</a>
      </div>
    </div>

    <ng-template #tasksTimelineTemplate>
      <nz-timeline class="p-20">
        <nz-timeline-item [nzDot]="timeWaitTemplate">
          Data Entry
          <small class="d-b">
            PAPER ENTRY assigned to Jane Doe
          </small>
        </nz-timeline-item>
        <nz-timeline-item nzColor="green">
          Policy initialisation
          <small class="d-b">15 Jan 2019 at 11:01 AM (15 minutes ago)</small>
        </nz-timeline-item>
      </nz-timeline>
    </ng-template>
    <ng-template #timeWaitTemplate>
      <i nz-icon nzType="clock-circle-o" style="font-size: 16px;"></i>
    </ng-template>

  </div>

  <div *ngIf="_state=='claimPayout' " class="card-summary-title card-summary-ribbon">

    <h3 class="prominent">
      <div class="flex flex-horiz-space-bw flex-vert-center">
        <div>
          <span>{{getDO(policyData)?.clmIntimationNum}}</span>&nbsp;
          <nz-tag *ngIf="getDO(policyData)?.eventTypeCd" [nzColor]="'#333'">
            {{(getDO(policyData)?.eventTypeCd | technicalTranslate) || ''}}</nz-tag>
          <nz-tag [nzColor]="'#2db7f5'">
            {{getDO(policyData)?.stageCd != null? (getDO(policyData)?.stageCd | technicalTranslate) : 'New Registration' }}
          </nz-tag>
          <!-- <nz-tag [nzColor]="'#2db7f5'">{{getDO(policyData)?.stageCd}}</nz-tag> -->
          <nz-tag *ngIf="lastUpdatedUser || lastUpdatedDate" class="tag-right"><span>Last updated <span
                *ngIf="lastUpdatedUser" style="font-weight: 500;">by {{lastUpdatedUser}}, </span></span>
            <span *ngIf="lastUpdatedDate">on <span
                style="font-weight: 500;">{{lastUpdatedDate | date : appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR}}</span>
            </span>
          </nz-tag>


        </div>
        <div>
          <!-- Mark as favourite -->
          <button nz-button nzType="default" nzSize="small" class="m-r-5" (click)="freezeToggle()">
            <span *ngIf="caseIsFrozen">Un-</span>Freeze
          </button>
          <a class="clickable col-white">
            <i *ngIf="isStarred" (click)="starThis()" nz-icon nzType="star" nzTheme="fill"></i>
            <i *ngIf="!isStarred" (click)="starThis()" nz-icon nzType="star" nzTheme="outline"></i>
          </a>
        </div>
      </div>
    </h3>

    <div class="card-summary-ribbon-grid card-summary-ribbon-grid-duo">

      <div>
        <div class="grid grid-3x p-b-10">
          <div *ngFor="let item of metaDataArray">
            <strong class="c-s-heading">{{item.description}}</strong>

            <span *ngIf="item.key !=='proposalNum' "> {{claimRibbonObj[item.key]?claimRibbonObj[item.key] : "-"}} </span>
            <nz-select nzShowSearch *ngIf="item.key =='proposalNum' && proposalDOs && proposalDOs.length > 0" class=""
              nzPlaceHolder="Choose" nzSize='small' (ngModelChange)="changeRibbonContains($event)"
              [(ngModel)]="selectPolNum">
              <nz-option *ngFor="let item of proposalDOs" [nzLabel]="item?.proposalNum" [nzValue]="item?.proposalNum">
              </nz-option>
            </nz-select>
          </div>
        </div>

        <div>
          <nz-tooltip nzTooltipTitle="3 done / 3 in progress / 4 to do" nzTooltipPlacement="bottom">
            <nz-progress nz-tooltip [nzPercent]="30" [nzSuccessPercent]="60" nzStatus="active"></nz-progress>
          </nz-tooltip>
        </div>
      </div>

      <div class="card-summary-ribbon-links">
        <h5>Actions</h5>
        <a (click)="activityPanel(1)"><i class="anticon anticon-profile"></i> Activity Timeline</a>
        <a (click)="workflowPanel(1)"><i class="anticon anticon-audit"></i> Workflow Audit</a>
        <a (click)="corresPanel(1)"><i class="anticon anticon-inbox"></i> Correspondence</a>
        <a (click)="policyPanel(1)" [class.anchor-is-disabled]='!selectedClient'><i
            class="anticon anticon-file-protect"></i> View Policy</a>
        <a (click)="profilePanel(1)" [class.anchor-is-disabled]='!selectedClient'><i class="anticon anticon-user"></i>
          View Profile</a>
      </div>
      <div class="card-summary-ribbon-links">
        <h5>Supporting</h5>
        <a *ngIf="!isNew" (click)="notesPanel(1)"><i class="anticon anticon-read"></i> Notes</a>
        <a (click)="documentOpenEmitTransation()"><i class="anticon anticon-paper-clip"></i> Documents</a>
        <a (click)="worksheetPanel(1)"><i class="anticon anticon-reconciliation"></i> Claim Worksheet</a>
      </div>
    </div>

    <ng-template #tasksTimelineTemplate>
      <nz-timeline class="p-20">
        <nz-timeline-item [nzDot]="timeWaitTemplate">
          Data Entry
          <small class="d-b">
            PAPER ENTRY assigned to Jane Doe
          </small>
        </nz-timeline-item>
        <nz-timeline-item nzColor="green">
          Policy initialisation
          <small class="d-b">15 Jan 2019 at 11:01 AM (15 minutes ago)</small>
        </nz-timeline-item>
      </nz-timeline>
    </ng-template>
    <ng-template #timeWaitTemplate>
      <i nz-icon nzType="clock-circle-o" style="font-size: 16px;"></i>
    </ng-template>

  </div>

  <div
    *ngIf="_state=='claimUWReferral' || _state=='claimHOReferralWaiver' || _state=='claimHOReferralOpinion' || _state=='claimsCommitteeReferral' "
    class="card-summary-title card-summary-ribbon">

    <h3 class="prominent">
      <div class="flex flex-horiz-space-bw flex-vert-center">
        <div>
          <span>{{getDO(policyData)?.claimNum}}</span>&nbsp;
          <nz-tag *ngIf="getDO(policyData)?.eventTypeCd" [nzColor]="'#333'">
            {{(getDO(policyData)?.eventTypeCd | technicalTranslate) || ''}}</nz-tag>
          <nz-tag [nzColor]="'#2db7f5'">
            {{getDO(policyData)?.stageCd != null? (getDO(policyData)?.stageCd | technicalTranslate) : 'New Registration'}}
          </nz-tag>
          <!-- <nz-tag [nzColor]="'#2db7f5'">{{getDO(policyData)?.stageCd}}</nz-tag> -->
          <nz-tag *ngIf="lastUpdatedUser || lastUpdatedDate" class="tag-right"><span>Last updated <span
                *ngIf="lastUpdatedUser" style="font-weight: 500;">by {{lastUpdatedUser}}, </span></span>
            <span *ngIf="lastUpdatedDate">on <span
                style="font-weight: 500;">{{lastUpdatedDate | date : appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR}}</span>
            </span>
          </nz-tag>


        </div>
        <div>
          <!-- Mark as favourite -->
          <button nz-button nzType="default" nzSize="small" class="m-r-5" (click)="freezeToggle()">
            <span *ngIf="caseIsFrozen">Un-</span>Freeze
          </button>
          <a class="clickable col-white">
            <i *ngIf="isStarred" (click)="starThis()" nz-icon nzType="star" nzTheme="fill"></i>
            <i *ngIf="!isStarred" (click)="starThis()" nz-icon nzType="star" nzTheme="outline"></i>
          </a>
        </div>
      </div>
    </h3>

    <div class="card-summary-ribbon-grid card-summary-ribbon-grid-duo">

      <div>
        <div class="grid grid-3x p-b-10">
          <div *ngFor="let item of metaDataArray">
            <strong class="c-s-heading">{{item.description}}</strong>

            <span *ngIf="item.key !=='proposalNum' "> {{claimRibbonObj[item.key]?claimRibbonObj[item.key] : "-"}} </span>
            <nz-select nzShowSearch *ngIf="item.key =='proposalNum' && proposalDOs && proposalDOs.length > 0" class=""
              nzPlaceHolder="Choose" nzSize='small' (ngModelChange)="changeRibbonContains($event)"
              [(ngModel)]="selectPolNum">
              <nz-option *ngFor="let item of proposalDOs" [nzLabel]="item?.proposalNum" [nzValue]="item?.proposalNum">
              </nz-option>
            </nz-select>
          </div>
        </div>

        <div>
          <nz-tooltip nzTooltipTitle="3 done / 3 in progress / 4 to do" nzTooltipPlacement="bottom">
            <nz-progress nz-tooltip [nzPercent]="30" [nzSuccessPercent]="60" nzStatus="active"></nz-progress>
          </nz-tooltip>
        </div>
      </div>

      <div class="card-summary-ribbon-links">
        <h5>Actions</h5>
        <a (click)="activityPanel(1)"><i class="anticon anticon-profile"></i> Activity Timeline</a>
        <a (click)="workflowPanel(1)"><i class="anticon anticon-audit"></i> Workflow Audit</a>
        <a (click)="corresPanel(1)"><i class="anticon anticon-inbox"></i> Correspondence</a>
        <a (click)="policyPanel(1)" [class.anchor-is-disabled]='!selectedClient'><i
            class="anticon anticon-file-protect"></i> View Policy</a>
        <a (click)="profilePanel(1)" [class.anchor-is-disabled]='!selectedClient'><i class="anticon anticon-user"></i>
          View Profile</a>
      </div>
      <div class="card-summary-ribbon-links">
        <h5>Supporting</h5>
        <a *ngIf="!isNew" (click)="notesPanel(1)"><i class="anticon anticon-read"></i> Notes</a>
        <a (click)="documentOpenEmitTransation()"><i class="anticon anticon-paper-clip"></i> Documents</a>
        <a (click)="worksheetPanel(1)"><i class="anticon anticon-reconciliation"></i> Claim Worksheet</a>
      </div>
    </div>

    <ng-template #tasksTimelineTemplate>
      <nz-timeline class="p-20">
        <nz-timeline-item [nzDot]="timeWaitTemplate">
          Data Entry
          <small class="d-b">
            PAPER ENTRY assigned to Jane Doe
          </small>
        </nz-timeline-item>
        <nz-timeline-item nzColor="green">
          Policy initialisation
          <small class="d-b">15 Jan 2019 at 11:01 AM (15 minutes ago)</small>
        </nz-timeline-item>
      </nz-timeline>
    </ng-template>
    <ng-template #timeWaitTemplate>
      <i nz-icon nzType="clock-circle-o" style="font-size: 16px;"></i>
    </ng-template>

  </div>

  <div *ngIf="_state=='claimReinsReferral' " class="card-summary-title card-summary-ribbon">

    <h3 class="prominent">
      <div class="flex flex-horiz-space-bw flex-vert-center">
        <div>
          <span>{{getDO(policyData)?.claimNum}}</span>&nbsp;
          <nz-tag *ngIf="getDO(policyData)?.eventTypeCd" [nzColor]="'#333'">
            {{(getDO(policyData)?.eventTypeCd | technicalTranslate) || ''}}</nz-tag>
          <nz-tag [nzColor]="'#2db7f5'">
            {{getDO(policyData)?.stageCd != null? (getDO(policyData)?.stageCd | technicalTranslate) : 'New Registration' }}
          </nz-tag>
          <!-- <nz-tag [nzColor]="'#2db7f5'">{{getDO(policyData)?.stageCd}}</nz-tag> -->
          <nz-tag *ngIf="lastUpdatedUser || lastUpdatedDate" class="tag-right"><span>Last updated <span
                *ngIf="lastUpdatedUser" style="font-weight: 500;">by {{lastUpdatedUser}}, </span></span>
            <span *ngIf="lastUpdatedDate">on <span
                style="font-weight: 500;">{{lastUpdatedDate | date : appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR}}</span>
            </span>
          </nz-tag>


        </div>
        <div>
          <!-- Mark as favourite -->
          <button nz-button nzType="default" nzSize="small" class="m-r-5" (click)="freezeToggle()">
            <span *ngIf="caseIsFrozen">Un-</span>Freeze
          </button>
          <a class="clickable col-white">
            <i *ngIf="isStarred" (click)="starThis()" nz-icon nzType="star" nzTheme="fill"></i>
            <i *ngIf="!isStarred" (click)="starThis()" nz-icon nzType="star" nzTheme="outline"></i>
          </a>
        </div>
      </div>
    </h3>

    <div class="card-summary-ribbon-grid card-summary-ribbon-grid-duo">

      <div>
        <div class="grid grid-3x p-b-10">
          <div *ngFor="let item of metaDataArray">
            <strong class="c-s-heading">{{item.description}}</strong>

            <span *ngIf="item.key !=='proposalNum' "> {{claimRibbonObj[item.key]?claimRibbonObj[item.key] : "-"}} </span>
            <nz-select nzShowSearch *ngIf="item.key =='proposalNum' && proposalDOs && proposalDOs.length > 0" class=""
              nzPlaceHolder="Choose" nzSize='small' (ngModelChange)="changeRibbonContains($event)"
              [(ngModel)]="selectPolNum">
              <nz-option *ngFor="let item of proposalDOs" [nzLabel]="item?.proposalNum" [nzValue]="item?.proposalNum">
              </nz-option>
            </nz-select>
          </div>
        </div>

        <div>
          <nz-tooltip nzTooltipTitle="3 done / 3 in progress / 4 to do" nzTooltipPlacement="bottom">
            <nz-progress nz-tooltip [nzPercent]="30" [nzSuccessPercent]="60" nzStatus="active"></nz-progress>
          </nz-tooltip>
        </div>
      </div>

      <div class="card-summary-ribbon-links">
        <h5>Actions</h5>
        <a (click)="activityPanel(1)"><i class="anticon anticon-profile"></i> Activity Timeline</a>
        <a (click)="workflowPanel(1)"><i class="anticon anticon-audit"></i> Workflow Audit</a>
        <a (click)="corresPanel(1)"><i class="anticon anticon-inbox"></i> Correspondence</a>
        <a (click)="policyPanel(1)" [class.anchor-is-disabled]='!selectedClient'><i
            class="anticon anticon-file-protect"></i> View Policy</a>
        <a (click)="profilePanel(1)" [class.anchor-is-disabled]='!selectedClient'><i class="anticon anticon-user"></i>
          View Profile</a>
      </div>
      <div class="card-summary-ribbon-links">
        <h5>Supporting</h5>
        <a *ngIf="!isNew" (click)="notesPanel(1)"><i class="anticon anticon-read"></i> Notes</a>
        <a (click)="documentOpenEmitTransation()"><i class="anticon anticon-paper-clip"></i> Documents</a>
        <a (click)="worksheetPanel(1)"><i class="anticon anticon-reconciliation"></i> Claim Worksheet</a>
        <a (click)="analyticsModal=true"><i class="anticon anticon-dot-chart"></i>
          Analyze</a>
      </div>
    </div>

    <ng-template #tasksTimelineTemplate>
      <nz-timeline class="p-20">
        <nz-timeline-item [nzDot]="timeWaitTemplate">
          Data Entry
          <small class="d-b">
            PAPER ENTRY assigned to Jane Doe
          </small>
        </nz-timeline-item>
        <nz-timeline-item nzColor="green">
          Policy initialisation
          <small class="d-b">15 Jan 2019 at 11:01 AM (15 minutes ago)</small>
        </nz-timeline-item>
      </nz-timeline>
    </ng-template>
    <ng-template #timeWaitTemplate>
      <i nz-icon nzType="clock-circle-o" style="font-size: 16px;"></i>
    </ng-template>

  </div>


  <!--Added more 3 stages suggested by Ganesh -->


  <div *ngIf="_state=='claimMOReferral' " class="card-summary-title card-summary-ribbon">

    <h3 class="prominent">
      <div class="flex flex-horiz-space-bw flex-vert-center">
        <div>
          <span>{{getDO(policyData)?.claimNum}}</span>&nbsp;
          <nz-tag *ngIf="getDO(policyData)?.eventTypeCd" [nzColor]="'#333'">{{getDO(policyData)?.eventTypeCd}}</nz-tag>
          <nz-tag [nzColor]="'#2db7f5'">
            {{getDO(policyData)?.stageCd != null? (getDO(policyData)?.stageCd | technicalTranslate) : 'New Registration'}}
          </nz-tag>
          <!-- <nz-tag [nzColor]="'#2db7f5'">{{getDO(policyData)?.stageCd}}</nz-tag> -->
          <nz-tag *ngIf="lastUpdatedUser || lastUpdatedDate" class="tag-right"><span>Last updated <span
                *ngIf="lastUpdatedUser" style="font-weight: 500;">by {{lastUpdatedUser}}, </span></span>
            <span *ngIf="lastUpdatedDate">on <span
                style="font-weight: 500;">{{lastUpdatedDate | date : appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR}}</span>
            </span>
          </nz-tag>

        </div>
        <div>
          <!-- Mark as favourite -->
          <button nz-button nzType="default" nzSize="small" class="m-r-5" (click)="freezeToggle()">
            <span *ngIf="caseIsFrozen">Un-</span>Freeze
          </button>
          <a class="clickable col-white">
            <i *ngIf="isStarred" (click)="starThis()" nz-icon nzType="star" nzTheme="fill"></i>
            <i *ngIf="!isStarred" (click)="starThis()" nz-icon nzType="star" nzTheme="outline"></i>
          </a>
        </div>
      </div>
    </h3>

    <div class="card-summary-ribbon-grid card-summary-ribbon-grid-duo">

      <div>
        <div class="grid grid-3x p-b-10">
          <div *ngFor="let item of metaDataArray">
            <strong class="c-s-heading">{{item.description}}</strong>

            <span *ngIf="item.key !=='proposalNum' "> {{claimRibbonObj[item.key]?claimRibbonObj[item.key] : "-"}} </span>
            <nz-select nzShowSearch *ngIf="item.key =='proposalNum' && proposalDOs && proposalDOs.length > 0" class=""
              nzPlaceHolder="Choose" nzSize='small' (ngModelChange)="changeRibbonContains($event)"
              [(ngModel)]="selectPolNum">
              <nz-option *ngFor="let item of proposalDOs" [nzLabel]="item?.proposalNum" [nzValue]="item?.proposalNum">
              </nz-option>
            </nz-select>
          </div>
        </div>

        <div>
          <nz-tooltip nzTooltipTitle="3 done / 3 in progress / 4 to do" nzTooltipPlacement="bottom">
            <nz-progress nz-tooltip [nzPercent]="30" [nzSuccessPercent]="60" nzStatus="active"></nz-progress>
          </nz-tooltip>
        </div>
      </div>

      <div class="card-summary-ribbon-links">
        <h5>Actions</h5>
        <a (click)="activityPanel(1)"><i class="anticon anticon-profile"></i> Activity Timeline</a>
        <a (click)="workflowPanel(1)"><i class="anticon anticon-audit"></i> Workflow Audit</a>
        <a (click)="corresPanel(1)"><i class="anticon anticon-inbox"></i> Correspondence</a>
        <a (click)="policyPanel(1)" [class.anchor-is-disabled]='!selectedClient'><i
            class="anticon anticon-file-protect"></i> View Policy</a>
        <a (click)="profilePanel(1)" [class.anchor-is-disabled]='!selectedClient'><i class="anticon anticon-user"></i>
          View Profile</a>
      </div>
      <div class="card-summary-ribbon-links">
        <h5>Supporting</h5>
        <a *ngIf="!isNew" (click)="notesPanel(1)"><i class="anticon anticon-read"></i> Notes</a>
        <a (click)="documentOpenEmitTransation()"><i class="anticon anticon-paper-clip"></i> Documents</a>
        <a (click)="worksheetPanel(1)"><i class="anticon anticon-reconciliation"></i> Claim Worksheet</a>
        <a (click)="analyticsModal=true"><i class="anticon anticon-dot-chart"></i>
          Analyze</a>
      </div>
    </div>

    <ng-template #tasksTimelineTemplate>
      <nz-timeline class="p-20">
        <nz-timeline-item [nzDot]="timeWaitTemplate">
          Data Entry
          <small class="d-b">
            PAPER ENTRY assigned to Jane Doe
          </small>
        </nz-timeline-item>
        <nz-timeline-item nzColor="green">
          Policy initialisation
          <small class="d-b">15 Jan 2019 at 11:01 AM (15 minutes ago)</small>
        </nz-timeline-item>
      </nz-timeline>
    </ng-template>
    <ng-template #timeWaitTemplate>
      <i nz-icon nzType="clock-circle-o" style="font-size: 16px;"></i>
    </ng-template>

  </div>

  <div *ngIf="_state=='claimLegalReferral' " class="card-summary-title card-summary-ribbon">

    <h3 class="prominent">
      <div class="flex flex-horiz-space-bw flex-vert-center">
        <div>
          <span>{{getDO(policyData)?.claimNum}}</span>&nbsp;
          <nz-tag *ngIf="getDO(policyData)?.eventTypeCd" [nzColor]="'#333'">{{getDO(policyData)?.eventTypeCd}}</nz-tag>
          <nz-tag [nzColor]="'#2db7f5'">
            {{getDO(policyData)?.stageCd != null? (getDO(policyData)?.stageCd | technicalTranslate) : 'New Registration' }}
          </nz-tag>
          <!-- <nz-tag [nzColor]="'#2db7f5'">{{getDO(policyData)?.stageCd}}</nz-tag> -->
          <nz-tag *ngIf="lastUpdatedUser || lastUpdatedDate" class="tag-right"><span>Last updated <span
                *ngIf="lastUpdatedUser" style="font-weight: 500;">by {{lastUpdatedUser}}, </span></span>
            <span *ngIf="lastUpdatedDate">on <span
                style="font-weight: 500;">{{lastUpdatedDate | date : appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR}}</span>
            </span>
          </nz-tag>

        </div>
        <div>
          <!-- Mark as favourite -->
          <button nz-button nzType="default" nzSize="small" class="m-r-5" (click)="freezeToggle()">
            <span *ngIf="caseIsFrozen">Un-</span>Freeze
          </button>
          <a class="clickable col-white">
            <i *ngIf="isStarred" (click)="starThis()" nz-icon nzType="star" nzTheme="fill"></i>
            <i *ngIf="!isStarred" (click)="starThis()" nz-icon nzType="star" nzTheme="outline"></i>
          </a>
        </div>
      </div>
    </h3>

    <div class="card-summary-ribbon-grid card-summary-ribbon-grid-duo">

      <div>
        <div class="grid grid-3x p-b-10">
          <div *ngFor="let item of metaDataArray">
            <strong class="c-s-heading">{{item.description}}</strong>

            <span *ngIf="item.key !=='proposalNum' "> {{claimRibbonObj[item.key]?claimRibbonObj[item.key] : "-"}} </span>
            <nz-select nzShowSearch *ngIf="item.key =='proposalNum' && proposalDOs && proposalDOs.length > 0" class=""
              nzPlaceHolder="Choose" nzSize='small' (ngModelChange)="changeRibbonContains($event)"
              [(ngModel)]="selectPolNum">
              <nz-option *ngFor="let item of proposalDOs" [nzLabel]="item?.proposalNum" [nzValue]="item?.proposalNum">
              </nz-option>
            </nz-select>
          </div>
        </div>

        <div>
          <nz-tooltip nzTooltipTitle="3 done / 3 in progress / 4 to do" nzTooltipPlacement="bottom">
            <nz-progress nz-tooltip [nzPercent]="30" [nzSuccessPercent]="60" nzStatus="active"></nz-progress>
          </nz-tooltip>
        </div>
      </div>

      <div class="card-summary-ribbon-links">
        <h5>Actions</h5>
        <a (click)="activityPanel(1)"><i class="anticon anticon-profile"></i> Activity Timeline</a>
        <a (click)="workflowPanel(1)"><i class="anticon anticon-audit"></i> Workflow Audit</a>
        <a (click)="corresPanel(1)"><i class="anticon anticon-inbox"></i> Correspondence</a>
        <a (click)="policyPanel(1)" [class.anchor-is-disabled]='!selectedClient'><i
            class="anticon anticon-file-protect"></i> View Policy</a>
        <a (click)="profilePanel(1)" [class.anchor-is-disabled]='!selectedClient'><i class="anticon anticon-user"></i>
          View Profile</a>
      </div>
      <div class="card-summary-ribbon-links">
        <h5>Supporting</h5>
        <a *ngIf="!isNew" (click)="notesPanel(1)"><i class="anticon anticon-read"></i> Notes</a>
        <a (click)="documentOpenEmitTransation()"><i class="anticon anticon-paper-clip"></i> Documents</a>
        <a (click)="worksheetPanel(1)"><i class="anticon anticon-reconciliation"></i> Claim Worksheet</a>
        <a (click)="analyticsModal=true"><i class="anticon anticon-dot-chart"></i>
          Analyze</a>
      </div>
    </div>

    <ng-template #tasksTimelineTemplate>
      <nz-timeline class="p-20">
        <nz-timeline-item [nzDot]="timeWaitTemplate">
          Data Entry
          <small class="d-b">
            PAPER ENTRY assigned to Jane Doe
          </small>
        </nz-timeline-item>
        <nz-timeline-item nzColor="green">
          Policy initialisation
          <small class="d-b">15 Jan 2019 at 11:01 AM (15 minutes ago)</small>
        </nz-timeline-item>
      </nz-timeline>
    </ng-template>
    <ng-template #timeWaitTemplate>
      <i nz-icon nzType="clock-circle-o" style="font-size: 16px;"></i>
    </ng-template>

  </div>

  <div *ngIf="_state=='claimComplianceReferral' " class="card-summary-title card-summary-ribbon">

    <h3 class="prominent">
      <div class="flex flex-horiz-space-bw flex-vert-center">
        <div>
          <span>{{getDO(policyData)?.claimNum}}</span>&nbsp;
          <nz-tag *ngIf="getDO(policyData)?.eventTypeCd" [nzColor]="'#333'">{{getDO(policyData)?.eventTypeCd}}</nz-tag>
          <nz-tag [nzColor]="'#2db7f5'">
            {{getDO(policyData)?.stageCd != null? (getDO(policyData)?.stageCd | technicalTranslate) : 'New Registration'}}
          </nz-tag>
          <!-- <nz-tag [nzColor]="'#2db7f5'">{{getDO(policyData)?.stageCd}}</nz-tag> -->
          <nz-tag *ngIf="lastUpdatedUser || lastUpdatedDate" class="tag-right"><span>Last updated <span
                *ngIf="lastUpdatedUser" style="font-weight: 500;">by {{lastUpdatedUser}}, </span></span>
            <span *ngIf="lastUpdatedDate">on <span
                style="font-weight: 500;">{{lastUpdatedDate | date : appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR}}</span>
            </span>
          </nz-tag>

        </div>
        <div>
          <!-- Mark as favourite -->
          <button nz-button nzType="default" nzSize="small" class="m-r-5" (click)="freezeToggle()">
            <span *ngIf="caseIsFrozen">Un-</span>Freeze
          </button>
          <a class="clickable col-white">
            <i *ngIf="isStarred" (click)="starThis()" nz-icon nzType="star" nzTheme="fill"></i>
            <i *ngIf="!isStarred" (click)="starThis()" nz-icon nzType="star" nzTheme="outline"></i>
          </a>
        </div>
      </div>
    </h3>

    <div class="card-summary-ribbon-grid card-summary-ribbon-grid-duo">

      <div>
        <div class="grid grid-3x p-b-10">
          <div *ngFor="let item of metaDataArray">
            <strong class="c-s-heading">{{item.description}}</strong>

            <span *ngIf="item.key !=='proposalNum' "> {{claimRibbonObj[item.key]?claimRibbonObj[item.key] : "-"}} </span>
            <nz-select nzShowSearch *ngIf="item.key =='proposalNum' && proposalDOs && proposalDOs.length > 0" class=""
              nzPlaceHolder="Choose" nzSize='small' (ngModelChange)="changeRibbonContains($event)"
              [(ngModel)]="selectPolNum">
              <nz-option *ngFor="let item of proposalDOs" [nzLabel]="item?.proposalNum" [nzValue]="item?.proposalNum">
              </nz-option>
            </nz-select>
          </div>
        </div>

        <div>
          <nz-tooltip nzTooltipTitle="3 done / 3 in progress / 4 to do" nzTooltipPlacement="bottom">
            <nz-progress nz-tooltip [nzPercent]="30" [nzSuccessPercent]="60" nzStatus="active"></nz-progress>
          </nz-tooltip>
        </div>
      </div>

      <div class="card-summary-ribbon-links">
        <h5>Actions</h5>
        <a (click)="activityPanel(1)"><i class="anticon anticon-profile"></i> Activity Timeline</a>
        <a (click)="workflowPanel(1)"><i class="anticon anticon-audit"></i> Workflow Audit</a>
        <a (click)="corresPanel(1)"><i class="anticon anticon-inbox"></i> Correspondence</a>
        <a (click)="policyPanel(1)"><i class="anticon anticon-file-protect"></i> View Policy</a>
        <a (click)="profilePanel(1)"><i class="anticon anticon-user"></i> View Profile</a>
      </div>
      <div class="card-summary-ribbon-links">
        <h5>Supporting</h5>
        <a *ngIf="!isNew" (click)="notesPanel(1)"><i class="anticon anticon-read"></i> Notes</a>
        <a (click)="documentOpenEmitTransation()"><i class="anticon anticon-paper-clip"></i> Documents</a>
        <a (click)="worksheetPanel(1)"><i class="anticon anticon-reconciliation"></i> Claim Worksheet</a>
        <a (click)="analyticsModal=true"><i class="anticon anticon-dot-chart"></i>
          Analyze</a>
      </div>
    </div>

    <ng-template #tasksTimelineTemplate>
      <nz-timeline class="p-20">
        <nz-timeline-item [nzDot]="timeWaitTemplate">
          Data Entry
          <small class="d-b">
            PAPER ENTRY assigned to Jane Doe
          </small>
        </nz-timeline-item>
        <nz-timeline-item nzColor="green">
          Policy initialisation
          <small class="d-b">15 Jan 2019 at 11:01 AM (15 minutes ago)</small>
        </nz-timeline-item>
      </nz-timeline>
    </ng-template>
    <ng-template #timeWaitTemplate>
      <i nz-icon nzType="clock-circle-o" style="font-size: 16px;"></i>
    </ng-template>

  </div>
</ng-container>
<ng-container *ngIf="renderUsingConfig">

  <div class="card-summary-title card-summary-ribbon">

    <h3 class="prominent">
      <div class="flex flex-horiz-space-bw flex-vert-center">
        <div>
          <span *ngIf="newEntityNumber" nz-tooltip nzTooltipTitle="Entity Number">{{newEntityNumber}}</span>&nbsp;
          <nz-tag *ngIf="newEntityName" [nzColor]="'#333'"> {{newEntityName}}</nz-tag>
          <nz-tag *ngIf="getDO(initialPayloadInEdit)?.stageCd != null" [nzColor]="'#2db7f5'">
            {{getDO(initialPayloadInEdit)?.stageCd != null ? (getDO(initialPayloadInEdit)?.stageCd | technicalTranslate : 'policyStageCd') : '' }}
          </nz-tag>
          <!-- <nz-tag [nzColor]="'#2db7f5'">{{getDO(initialPayloadInEdit)?.stageCd}}</nz-tag> -->

          <nz-tag *ngIf="lastUpdatedUser || lastUpdatedDate" class="tag-right"><span>Last updated <span
                *ngIf="lastUpdatedUser" style="font-weight: 500;">by {{lastUpdatedUser}}, </span></span>
            <span *ngIf="lastUpdatedDate">on <span
                style="font-weight: 500;">{{lastUpdatedDate | date : appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR}}</span>
            </span>
          </nz-tag>
        </div>
        <div *ngIf="false">
          <!-- Mark as favourite -->
          <button nz-button nzType="default" nzSize="small" class="m-r-5" (click)="freezeToggle()">
            <span *ngIf="caseIsFrozen">Un-</span>Freeze
          </button>
          <a class="clickable col-white">
            <i *ngIf="isStarred" (click)="starThis()" nz-icon type="star" theme="fill"></i>
            <i *ngIf="!isStarred" (click)="starThis()" nz-icon type="star" nzTheme="outline"></i>
          </a>
        </div>
      </div>
    </h3>

    <div class="card-summary-ribbon-grid card-summary-ribbon-grid-duo">

      <!-- Read only Label Grid -Start -->
      <div>

        <app-dynamic-form [baseDOName]="configData.StateToDOMapper[_state]" FORMNAME="ProviderHospitalRibbonForm"
          [IO]="initialPayloadInEdit" [currentComponentName]="configData.StateToRibbonComponentMapper[_state]"
          [formMetaData]="configData.ComponentMetaDataConfiguration[configData.StateToRibbonComponentMapper[_state]]"
          [gridClass]="'grid-3x'" [labelMode]="true">
        </app-dynamic-form>


        <!-- <div>
          <nz-tooltip nzTooltipTitle="3 done / 3 in progress / 4 to do" nzTooltipPlacement="bottom">
            <nz-progress nz-tooltip [nzPercent]="30" [nzSuccessPercent]="60" nzStatus="active"></nz-progress>
          </nz-tooltip>
        </div> -->
      </div>
      <!-- Read only Label Grid -END -->


      <div class="card-summary-ribbon-links">
        <h5>Actions</h5>
        <a (click)="activityPanel(1)"><i class="anticon anticon-profile"></i> Activity Timeline</a>
        <a (click)="workflowPanel(1)"><i class="anticon anticon-audit"></i> Workflow Audit</a>
        <a (click)="corresPanel(1)"><i class="anticon anticon-inbox"></i> Correspondence</a>
        <!-- <a *ngIf="_state != 'DataEntry-HOSPITAL' && _state != 'DataVerificationTask-HOSPITAL'
                    && _state != 'DataEntry-CLINIC' && _state != 'DataVerificationTask-CLINIC'
                    && _state != 'DataEntry-DOCTOR' && _state != 'DataVerificationTask-DOCTOR'
                    && _state != 'DataEntry-PACKAGE' && _state != 'DataVerificationTask-PACKAGE'
                    && _state != 'DataEntry-PROVIDER' && _state != 'DataVerificationTask-PROVIDER'
                    && _state != 'DataEntry-DIAGNOSTIC' && _state != 'DataVerificationTask-DIAGNOSTIC'
                    && _state != 'DataEntry-LAB' && _state != 'DataVerificationTask-LAB'
                    && _state != 'DataEntry-PANEL' && _state != 'DataVerificationTask-PANEL'"
          (click)="policyPanel(1)" [class.anchor-is-disabled]='!selectedClient'><i nz-icon nzType="file"></i>Policy
          Details</a>
        <a *ngIf="_state != 'DataEntry-HOSPITAL' && _state != 'DataVerificationTask-HOSPITAL'
                    && _state != 'DataEntry-CLINIC' && _state != 'DataVerificationTask-CLINIC'
                    && _state != 'DataEntry-DOCTOR' && _state != 'DataVerificationTask-DOCTOR'
                    && _state != 'DataEntry-PACKAGE' && _state != 'DataVerificationTask-PACKAGE'
                    && _state != 'DataEntry-PROVIDER' && _state != 'DataVerificationTask-PROVIDER'
                    && _state != 'DataEntry-DIAGNOSTIC' && _state != 'DataVerificationTask-DIAGNOSTIC'
                    && _state != 'DataEntry-LAB' && _state != 'DataVerificationTask-LAB'
                    && _state != 'DataEntry-PANEL' && _state != 'DataVerificationTask-PANEL'"
          (click)="profilePanel(1)" [class.anchor-is-disabled]='!selectedClient'><i class="anticon anticon-user"></i>
          View Profile</a> -->
      </div>
      <div class="card-summary-ribbon-links">
        <h5>Supporting</h5>
        <a *ngIf="!isNew" (click)="notesPanel(1)"><i class="anticon anticon-read"
            [class.anchors-are-disabled]="!inputDataForEdit"></i> Notes</a>
        <a (click)="documentOpenEmitTransation()"><i class="anticon anticon-paper-clip"></i> Documents</a>
        <!-- <a *ngIf="_state != 'DataEntry-HOSPITAL' && _state != 'DataVerificationTask-HOSPITAL'
                    && _state != 'DataEntry-CLINIC' && _state != 'DataVerificationTask-CLINIC'
                    && _state != 'DataEntry-DOCTOR' && _state != 'DataVerificationTask-DOCTOR'
                    && _state != 'DataEntry-PACKAGE' && _state != 'DataVerificationTask-PACKAGE'
                    && _state != 'DataEntry-PROVIDER' && _state != 'DataVerificationTask-PROVIDER'
                    && _state != 'DataEntry-DIAGNOSTIC' && _state != 'DataVerificationTask-DIAGNOSTIC'
                    && _state != 'DataEntry-LAB' && _state != 'DataVerificationTask-LAB'
                    && _state != 'DataEntry-PANEL' && _state != 'DataVerificationTask-PANEL'"
          (click)="worksheetPanel(1)"><i class="anticon anticon-reconciliation"></i> Providers Worksheet</a>
        <a *ngIf="inboxFullPrivilege" (click)="analyticsModal=true"><i class="anticon anticon-dot-chart"></i>
          Analyze</a> -->
      </div>
    </div>

  </div>

</ng-container>

<!-- start dummy ribbon -->
<!-- / FOR DEMO ONLY -- REMOVE ME -->

<div id="ribbon" *ngIf="false">
  <div class="card-container">
    <div class="card-summary-title card-summary-ribbon">

      <h3 class="prominent">
        <div class="flex flex-horiz-space-bw flex-vert-center">
          <div>
            <span>#PP00900/920/HL172</span>&nbsp;
            <nz-tag [nzColor]="productTypeConfig.prodTagColor"><i nz-icon [nzType]="productTypeConfig.prodTagIcon"></i>
              {{productTypeConfig.prodSubType}}</nz-tag>
            <nz-tag [nzColor]="'#2db7f5'">Data Entry Complete</nz-tag>
          </div>
          <div>
            <button nz-button nzType="default" nzSize="small" class="m-r-5" (click)="freezeToggle()">
              <span *ngIf="caseIsFrozen">Un-</span>Freeze
            </button>
            <!-- Mark as favourite -->
            <a class="clickable col-white">
              <i *ngIf="isStarred" (click)="starThis()" nz-icon nzType="star" nzTheme="fill"></i>
              <i *ngIf="!isStarred" (click)="starThis()" nz-icon nzType="star" nzTheme="outline"></i>
            </a>
          </div>
        </div>
      </h3>

      <div class="card-summary-ribbon-grid card-summary-ribbon-grid-duo">
        <div>
          <div class="grid grid-3x grid-gap-10 p-b-10">
            <div *ngFor="let item of metaDataArray">
              <strong class="c-s-heading">{{item.description}}</strong>
              <span> {{claimRibbonObj[item.key]?claimRibbonObj[item.key] : "-"}}
              </span>
            </div>
            <!-- <div><strong class="c-s-heading">Stage</strong> Pending Manual Underwriting</div>
            <div><strong class="c-s-heading">Submission Date</strong> 12 Nov 2018, 10:15 AM</div>
            <div><strong class="c-s-heading">Status</strong> Data entry complete</div>
            <div><strong class="c-s-heading">Premium </strong> Rs. 50,000</div>
            <div><strong class="c-s-heading">Premium Status </strong>
              <nz-tag [nzColor]="'#d1861b'">Outstanding</nz-tag>
            </div> -->
          </div>

          <div>
            <nz-tooltip nzTitle="3 done / 3 in progress / 4 to do" nzPlacement="bottom">
              <nz-progress nz-tooltip [nzPercent]="percentCompleted" [nzSuccessPercent]="percentCompleted-20"
                nzStatus="active"></nz-progress>
            </nz-tooltip>
          </div>

        </div>

        <div class="card-summary-ribbon-links">
          <h5>Actions</h5>
          <a (click)="activityPanel(1)"><i class="anticon anticon-profile"></i> Activity Timeline</a>
          <a (click)="workflowPanel(1)"><i class="anticon anticon-audit"></i> Workflow Audit</a>
          <a (click)="corresPanel(1)"><i class="anticon anticon-inbox"></i> Correspondence</a>
          <a (click)="profilePanel(1)"><i class="anticon anticon-user"></i> View Profile</a>
        </div>
        <div class="card-summary-ribbon-links">
          <h5>Supporting</h5>
          <a (click)="notesPanel(1)"><i class="anticon anticon-read"></i> Notes</a>
          <a (click)="docuPanel(1)"><i class="anticon anticon-paper-clip"></i> Documents</a>
          <a (click)="worksheetPanel(1)"><i class="anticon anticon-reconciliation"></i> <span
              class="text-t-capitalize">&nbsp;{{productTypeConfig?.productType}}</span> Worksheet</a>
          <a (click)="analyticsModal=true"><i class="anticon anticon-dot-chart"></i> Analyze</a>
        </div>
      </div>

      <ng-template #tasksTimelineTemplate>
        <nz-timeline class="p-20">
          <nz-timeline-item [nzDot]="timeWaitTemplate">
            Data Entry
            <small class="d-b">
              PAPER ENTRY assigned to Jane Doe
            </small>
          </nz-timeline-item>
          <nz-timeline-item nzColor="green">
            Policy initialisation
            <small class="d-b">15 Jan 2019 at 11:01 AM (15 minutes ago)</small>
          </nz-timeline-item>
        </nz-timeline>
      </ng-template>
      <ng-template #timeWaitTemplate>
        <i nz-icon nzType="clock-circle-o" style="font-size: 16px;"></i>
      </ng-template>

    </div>
  </div>
</div>

<div *ngIf="_state=='proposal_ManualUw' || _state=='proposal_DataEntry' || _state=='proposal_CounterOffer' || _state == 'LIFEproposal_DataEntry'
             || _state == 'TRAVELproposal_DataEntry' || _state == 'PROPERTYproposal_DataEntry' || _state == 'MOTORproposal_DataEntry'
             || _state=='MOTORproposal_ManualUw' || _state=='TRAVELproposal_ManualUw' || _state=='LIFEproposal_ManualUw' || _state=='PROPERTYproposal_ManualUw'"
  class="card-summary-title card-summary-ribbon">

  <h3 class="prominent">
    <div class="flex flex-horiz-space-bw flex-vert-center">
      <div>
        <span>{{getDO(policyData)? getDO(policyData).proposalNum : ""}}</span>&nbsp;
        <nz-tag *ngIf="getDO(policyData)?.eventTypeCd" [nzColor]="'#333'">
          {{getDO(policyData)? (getDO(policyData)?.eventTypeCd | technicalTranslate) : "-"}}</nz-tag>
        <nz-tag [nzColor]="'#2db7f5'">
          {{getDO(policyData)?.baseProductFamilyCd != null? (getDO(policyData)?.baseProductFamilyCd | technicalTranslate) : 'New Proposal'}}
          <!-- {{appMetadataHandler.lifeLOB}} -->
        </nz-tag>
        <nz-tag *ngIf="getDO(policyData) && getDO(policyData).stageCd" [nzColor]="'green'">
          {{getDO(policyData)? (getDO(policyData).stageCd | technicalTranslate) : "-"}}
        </nz-tag>
        <nz-tag *ngIf="getDO(policyData)" [nzColor]="'green'">
          <i nz-icon nzType="heart"></i>
          {{getDO(policyData)?.baseProductCd != null? (getDO(policyData)?.baseProductCd | technicalTranslate) : 'New Proposal'}}
        </nz-tag>


      </div>
      <div>
        <button id="freezeButton" nz-button nzType="default" nzSize="small" class="m-r-5" (click)="freezeToggle()">
          <span *ngIf="caseIsFrozen">Un-</span>Freeze
        </button>
        <button *ngIf="appMetadataHandler.featureFlags.enableDataEntryMode" nz-button nzType="default" nzSize="small" class="m-r-5" (click)="enableDataEntryMode()">
          <span></span>Data Entry Mode
        </button>
        <a class="clickable col-white">
          <i *ngIf="isStarred" (click)="starThis()" nz-icon nzType="star" nzTheme="fill"></i>
          <i *ngIf="!isStarred" (click)="starThis()" nz-icon nzType="star" nzTheme="outline"></i>
        </a>
      </div>
    </div>
  </h3>

  <div class="card-summary-ribbon-grid card-summary-ribbon-grid-customer360">

    <div>
      <div class="grid grid-3x p-b-10">
        <div class="ribbonFields" *ngFor="let item of metaDataArray">
          <strong class="c-s-heading">{{item.description}}</strong>
          <span *ngIf="!item.date && !item.formatter && item.key !== 'premiumStatusCd' && item.key != 'proposalNum'">
            {{underwritingRibbonObj[item.key]?(underwritingRibbonObj[item.key] | technicalTranslate) : "-"}} </span>
          <span *ngIf="!item.date && !item.formatter && item.key !== 'premiumStatusCd' && item.key == 'proposalNum'">
              {{underwritingRibbonObj[item.key]?(underwritingRibbonObj[item.key]) : "-"}} </span>
          <span *ngIf="item.date">
            {{underwritingRibbonObj[item.key]?(underwritingRibbonObj[item.key] | date: appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR) : "-"}}
          </span>
          <span *ngIf="item.formatter">
            {{underwritingRibbonObj[item.key]?(underwritingRibbonObj[item.key] | CurrencyFormatter : (underwritingRibbonObj['currencyCd'] || appMetadataHandler.productCurrencyCd ||  appMetadataHandler.companyCurrencyCd || appMetadataHandler.currentCountryCdValue)) : "-"}} </span>
          <span *ngIf="!item.date && !item.formatter && item.key === 'premiumStatusCd'">
            <nz-tag *ngIf="underwritingRibbonObj[item.key]=='OUTSTANDING'" [nzColor]="'brown'">
              {{underwritingRibbonObj[item.key]?(underwritingRibbonObj[item.key] | technicalTranslate) : "-"}}</nz-tag>
            <nz-tag *ngIf="underwritingRibbonObj[item.key]!='OUTSTANDING'" [nzColor]="'green'">
              {{underwritingRibbonObj[item.key]?(underwritingRibbonObj[item.key] | technicalTranslate) : "-"}}</nz-tag>
          </span>
        </div>
      </div>

      <div>
        <nz-tooltip nzTitle="Progress" nzPlacement="bottom">
          <nz-progress nz-tooltip [nzPercent]="progressPercentage" [nzSuccessPercent]="progressPercentage"
            nzStatus="active"></nz-progress>
        </nz-tooltip>
      </div>
    </div>

    <div class="card-summary-ico-big" >
      <div id="videoCallLink" class="card-action-ico" (click)="modalUsrCallVideo=true" [class.anchor-is-disabled]="userRole == 'PROPOSAL_BRANCH_OFFICER'">
        <i nz-icon nzType="video-camera" nzTheme="outline"></i>
        <span>Video Call</span>
      </div>
      <div id='callLink' class="card-action-ico" (click)="modalUsrCall=true" [class.anchor-is-disabled]="userRole == 'PROPOSAL_BRANCH_OFFICER'">
        <i nz-icon nzType="mobile" nzTheme="outline"></i>
        <span>Call</span>
      </div>
    </div>

    <div class="card-summary-ribbon-links">
      <h5>Actions</h5>
      <a id="activityTimelineLink" (click)="activityPanel(1)">
        <i class="anticon anticon-profile"></i> Activity Timeline</a>
      <a id="workflowAuditLink" (click)="workflowPanel(1)" [class.anchor-is-disabled]="userRole == 'PROPOSAL_BRANCH_OFFICER'">
        <i class="anticon anticon-audit"></i> Workflow Audit</a>
      <a id="correspondenceLink" (click)="corresPanel(1)">
        <i class="anticon anticon-inbox"></i> Correspondence</a>
      <a id="viewProposalLink" (click)="policyPanel(1)" [class.anchor-is-disabled]="userRole == 'PROPOSAL_BRANCH_OFFICER'">
        <i class="anticon anticon-file-protect"></i> View Proposal</a>
      <a id="allProfilesLink" (click)="allProfilePanel(1)" [class.anchor-is-disabled]="userRole == 'PROPOSAL_BRANCH_OFFICER'">
        <i class="anticon anticon-user"></i> All Profiles</a>
      <a *ngIf="appMetadataHandler.featureFlags.enableRiskSummarization" id="allProfilesLink" (click)="riskSummarization()" [class.anchor-is-disabled]="userRole == 'PROPOSAL_BRANCH_OFFICER'">
        <i class="anticon anticon-user"></i> Risk Summarization</a>
      <!-- <a id="allProfilesLink" (click)="policySummary(1)">
        <i class="anticon anticon-user"></i> Policy Summary</a> -->
    </div>
    <div class="card-summary-ribbon-links">
      <h5>Supporting</h5>
      <a id="notesLink" *ngIf="!isNew" (click)="notesPanel(1)" [class.anchor-is-disabled]="userRole == 'PROPOSAL_BRANCH_OFFICER'">
        <i class="anticon anticon-read"></i> Notes</a>
      <a id="documentsLink" (click)="documentOpenEmitTransation()">
        <i class="anticon anticon-paper-clip"></i> Documents</a>
      <a *ngIf="_state=='proposal_ManualUw'" (click)="underwritingWorksheetModal=true" [class.anchor-is-disabled]="userRole == 'PROPOSAL_BRANCH_OFFICER'">
        <i class="anticon anticon-reconciliation"></i> UW Worksheet</a>
      <a (click)="analyticsModal=true" [class.anchor-is-disabled]="userRole == 'PROPOSAL_BRANCH_OFFICER'">
        <i class="anticon anticon-dot-chart"></i> Analyze</a>
      <!-- <a *ngIf="_state=='proposal_ManualUw'" (click)="fraudAnalyticsModal=true" [class.anchor-is-disabled]="userRole == 'PROPOSAL_BRANCH_OFFICER'">
        <i nz-icon nzType="radar-chart" nzTheme="outline"></i> Fraud Analytics</a> -->
      <a id="medicalRiskLink" (click)="medicalRiskModal=true" [class.anchor-is-disabled]="userRole == 'PROPOSAL_BRANCH_OFFICER'">
        <i nz-icon nzType="file-done" nzTheme="outline"></i> Medical Risk</a>
      <!-- <a id="similarCasesLink" (click)="fetchSimilarCases()" [class.anchor-is-disabled]="userRole == 'PROPOSAL_BRANCH_OFFICER'">
        <i nz-icon nzType="scan" nzTheme="outline"></i> Similar Underwriting Decisions</a> -->
    </div>
  </div>

  <ng-template #tasksTimelineTemplate>
    <nz-timeline class="p-20">
      <nz-timeline-item [nzDot]="timeWaitTemplate">
        Data Entry
        <small class="d-b">
          PAPER ENTRY assigned to Jane Doe
        </small>
      </nz-timeline-item>
      <nz-timeline-item nzColor="green">
        Policy initialisation
        <small class="d-b">15 Jan 2019 at 11:01 AM (15 minutes ago)</small>
      </nz-timeline-item>
    </nz-timeline>
  </ng-template>
  <ng-template #timeWaitTemplate>
    <i nz-icon nzType="clock-circle-o" style="font-size: 16px;"></i>
  </ng-template>

</div>

<!-- <pre>{{getDO(policyData) | json}}</pre> -->
<!--end dummy ribbon -->

<!--Policy summmary -->
<nz-drawer [nzClosable]="true" [nzWidth]="750" [nzVisible]="policyPanelOpen" [nzPlacement]="'right'"
  nzTitle="Proposal Details" [nzOffsetX]="profilePanelOpen ? 80 : 0" (nzOnClose)="policyPanel(0)">
  <ng-container *nzDrawerContent>
  <app-view-policy-summary [IO]="policyData" [transactionState]="_state"></app-view-policy-summary>
  </ng-container>
</nz-drawer>


<!-- Profile summary -->
<nz-drawer [nzClosable]="true" [nzWidth]="550" [nzVisible]="profilePanelOpen" [nzPlacement]="'right'"
  nzTitle="Insured Details" (nzOnClose)="profilePanel(0)">
  <ng-container *nzDrawerContent>
  <app-view-profile-summary [IO]="policyData" [transactionState]="_state"></app-view-profile-summary>
  </ng-container>
</nz-drawer>

<!-- All Profiles -->
<nz-drawer [nzClosable]="true" [nzWidth]="550" [nzVisible]="allProfilePanelOpen" [nzPlacement]="'right'"
  nzTitle="All Profiles" (nzOnClose)="allProfilePanel(0)">
  <ng-container *nzDrawerContent>
  <app-view-all-profiles [IO]="policyData" [transactionState]="_state"></app-view-all-profiles>
  </ng-container>
</nz-drawer>

<!--Workflow   -->
<!-- <nz-drawer [nzClosable]="true" [nzWidth]="390" [nzPlacement]="'right'" nzTitle="Workflow Audit"
  [nzVisible]="workflowPanelOpen" (nzOnClose)="workflowPanel(0,0)">
  <ng-container *nzDrawerContent>
  <app-claims-workflow-audit [IO]="policyData" transactionState="workflow"></app-claims-workflow-audit>
  </ng-container>
</nz-drawer> -->


<!--Workflow   -->
<nz-drawer [nzClosable]="true" [nzWidth]="500" [nzPlacement]="'right'" nzTitle="Workflow Audit"
  [nzVisible]="workflowPanelOpen" (nzOnClose)="workflowPanel(0,0)">
  <ng-container *nzDrawerContent>
    <app-claims-workflow-audit [IO]="policyData" [DO]="DOName" transactionState="_state"></app-claims-workflow-audit>
  </ng-container>
</nz-drawer>

<!--Activity log  -->
<nz-drawer [nzClosable]="true" [nzWidth]="390" [nzPlacement]="'right'" nzTitle="Activity Timeline"
  [nzVisible]="activityPanelOpen" (nzOnClose)="activityPanel(0)">
  <ng-container *nzDrawerContent>
    <app-claims-activity-timeline [IO]="policyData" [DO]="DOName" transactionState="activity"></app-claims-activity-timeline>
  </ng-container>
</nz-drawer>


<!-- Document manager -->

<nz-drawer [nzClosable]="true" [nzWidth]="390" [nzPlacement]="'right'" nzTitle="Documents" [nzVisible]="docuPanelOpen"
  (nzOnClose)="docuPanel(0)">
  <ng-container *nzDrawerContent>
  <div *ngIf="docuPanelOpen">

    <nz-collapse>
      <nz-collapse-panel *ngFor="let panel of uploadArray; let i = index;"
        [nzHeader]="'Doc. '+(i+1)+': Additional Proof'">
        <div>
          <!-- Selection of Type -->
          <div class="flex flex-horiz-space-bw p-b-10">
            <div>
              <nz-select nzShowSearch [ngModel]="'0'">
                <nz-option [nzLabel]="'Death Certificate'" [nzValue]="'0'"></nz-option>
                <nz-option [nzLabel]="'Additional Proof'" [nzValue]="'Email'"></nz-option>
              </nz-select>
            </div>
            <span>
              <button nz-button nzType="dashed" nz-popconfirm nzPopconfirmTitle="Remove this section?" nzOkText="Remove"
                nzCancelText="Cancel" (nzOnConfirm)="removeUploadRow()"><i class="anticon anticon-delete"></i></button>
            </span>
          </div>
          <!-- Upload -->
          <nz-upload class="upload-list-inline" nzAction="https://jsonplaceholder.typicode.com/posts/"
            nzListType="picture" [(nzFileList)]="defaultUploadsList">
            <button nz-button>
              <span><i nz-icon nzType="upload" class="anticon anticon-upload"></i> Upload</span>
            </button>
          </nz-upload>

          <h4 class="d-b m-t-10">Requested Date</h4>
          <nz-date-picker nzFormat="dd MMM yyyy" style="width:100%" [nzFormat]="appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR"></nz-date-picker>

          <h4 class="d-b m-t-10">Received Date</h4>
          <nz-date-picker nzFormat="dd MMM yyyy" style="width:100%" [nzFormat]="appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR"></nz-date-picker>

          <div class="flexie-auto-grid">
            <div>
              <h4 class="d-b m-t-10">Visibility</h4>
              <nz-select nzShowSearch class="w-100-pc" nzPlaceHolder="Select post visibility">
                <nz-option nzLabel="Private (only me)" nzValue="0"></nz-option>
                <nz-option nzLabel="Public (everyone)" nzValue="1"></nz-option>
              </nz-select>
            </div>
            <div>
              <h4 class="d-b m-t-10">Status</h4>
              <nz-select nzShowSearch class="w-100-pc" [ngModel]="'0'">
                <nz-option [nzLabel]="'Identified'" [nzValue]="'1'"></nz-option>
                <nz-option [nzLabel]="'Waived'" [nzValue]="'0'"></nz-option>
                <nz-option [nzLabel]="'Received'" [nzValue]="'2'"></nz-option>
                <nz-option [nzLabel]="'Fullfilled'" [nzValue]="'3'"></nz-option>
              </nz-select>
            </div>
          </div>

          <h4 class="d-b m-t-10">Comments</h4>
          <textarea class="w-100-pc" rows="2" nz-input placeholder="Comments"></textarea>
        </div>
      </nz-collapse-panel>
    </nz-collapse>

    <button nz-button (click)="addUploadRow()" class="d-b m-t-20">Add More</button>

  </div>
</ng-container>
</nz-drawer>


<!--correspondence  -->

<nz-drawer *ngIf="false" [nzClosable]="true" [nzWidth]="390" [nzPlacement]="'right'" nzTitle="Correspondence`"
  [nzVisible]="corresPanelOpen" (nzOnClose)="corresPanel(0)">
  <ng-container *nzDrawerContent>
  <div>

    <div class="p-b-10 flex flex-horiz-space-bw">
      <div></div>
      <button nz-button nzType="primary" (click)="openCorrModal()">New Correspondence</button>
    </div>

    <nz-timeline>
      <nz-timeline-item nzColor="green">
        <h4 class="f-w-600">eMail <nz-tag [nzColor]="'green'">Sent</nz-tag>
        </h4>
        <p><i class="anticon anticon-calendar"></i>5 Apr 2019 10:12 AM (5 days ago)</p>
        <p>
          To: riya@gmail.com <br>
          Message: Your proposal is being processed <br>
          Attachment: <a>P0000107.EML</a>
        </p>
      </nz-timeline-item>
      <nz-timeline-item nzColor="green">
        <h4 class="f-w-600">SMS <nz-tag [nzColor]="'green'">Sent</nz-tag>
        </h4>
        <p><i class="anticon anticon-calendar"></i>5 Apr 2019 10:12 AM (5 days ago)</p>
        <p>
          To: 9809862272 <br>
          Message: Your proposal is being processed
        </p>
      </nz-timeline-item>
    </nz-timeline>
  </div>
  </ng-container>
</nz-drawer>

<!-- New correspondence -->
<nz-modal *ngIf="false" [(nzVisible)]="modalCorrespNew" nzTitle="New Correspondence"
  (nzOnCancel)="modalCorrespNew=false" (nzOnOk)="modalCorrespNew=false" nzOkText="Send" nzWidth="75%" nzZIndex="=1400">
  <ng-container *nzModalContent>
  <div *ngIf="modalCorrespNew">

    <nz-radio-group [(ngModel)]="correspType" [nzButtonStyle]="'solid'" [nzSize]="'default'">
      <label nz-radio-button nzValue="email"><i nz-icon nzType="mail" nzTheme="outline"></i> Email</label>
      <label nz-radio-button nzValue="sms"><i nz-icon nzType="mobile" nzTheme="outline"></i> SMS</label>
      <label nz-radio-button nzValue="pdf"><i nz-icon nzType="file-pdf" nzTheme="outline"></i> PDF</label>
    </nz-radio-group>

    <div *ngIf="'email'==correspType">
      <h4 class="d-b m-t-20">To</h4>
      <!-- Multi emails; ENTER to add new entry -->
      <nz-select nzShowSearch nzMode="tags" style="width: 100%;">
        <nz-option nzLabel="liam@thehemsworths.com" nzValue="liam@thehemsworths.com"></nz-option>
        <nz-option nzLabel="chris@thehemsworths.com" nzValue="chris@thehemsworths.com"></nz-option>
        <nz-option nzLabel="robert@thehemsworths.com" nzValue="robert@thehemsworths.com"></nz-option>
      </nz-select>

      <div class="flex flex-horiz-space-bw p-10 bg-grey-e9 m-t-20 m-b-10">
        <div class="flexie-auto-grid">
          <div>
            <small class="d-b text-a-left col-dark">Select replacement</small>
            <nz-select nzShowSearch style="width:100%" [(ngModel)]="replacementSelected"
              (ngModelChange)="replacementSelect(replacementSelected.value)">
              <nz-option *ngFor="let i of replacementArray" [nzLabel]="i.key" [nzValue]="i.value"></nz-option>
            </nz-select>
          </div>
          <div>
            <small class="d-b text-a-left col-dark">Copy-paste code</small>
            <!-- One-way bound ! -->
            <input type="text" nz-input [ngModel]="replacementSelected" name="replacement" #selectionInput
              (click)="selectionInput.select()" />
          </div>
        </div>
        <div>
          <small class="d-b text-a-right col-dark">Template</small>
          <nz-select nzShowSearch [ngModel]="'Document Missing - Death Certificate'">
            <nz-option nzLabel="Document Missing - Death Certificate" nzValue="Document Missing - Death Certificate">
            </nz-option>
            <nz-option nzLabel="Document Missing - Medical Records" nzValue="Document Missing - Medical Records">
            </nz-option>
          </nz-select>
        </div>
      </div>

      <h4 class="d-b">Subject</h4>
      <input type="text" nz-input class="w-100-pc d-b" [(ngModel)]="correspondenceSubject">

      <h4 class="d-b m-t-20">Content</h4>

      <angular-editor [(ngModel)]="correspondenceRichText"></angular-editor>

      <!-- Attach / Upload -- >
      <h4 class="d-b m-t-20">Attach Files/Documents</h4>
      <nz-upload
        nzType="drag"
        [nzMultiple]="true"
        [nzLimit]="2"
        nzAction="https://jsonplaceholder.typicode.com/posts/"
        (nzChange)="handleFileUpload($event)">
        <p class="ant-upload-drag-icon">
          <i nz-icon nzType="inbox" class="anticon anticon-inbox"></i>
        </p>
        <p class="ant-upload-text">Click or drag file to this area to upload</p>
        <p class="ant-upload-hint">
          Single file & bulk upload supported. Strictly prohibited from uploading internal company data or other confidential data
        </p>
      </nz-upload>
      < !-- -->


    </div>

    <div *ngIf="'pdf'==correspType">
      <h4 class="d-b m-t-20">Content</h4>
      <div class="flex flex-horiz-space-bw p-10 bg-grey-e9 m-t-20 m-b-10">
        <div class="flexie-auto-grid">
          <div>
            <small class="d-b text-a-left col-dark">Select replacement</small>
            <nz-select nzShowSearch style="width:100%" [(ngModel)]="replacementSelected"
              (ngModelChange)="replacementSelect(replacementSelected.value)">
              <nz-option *ngFor="let i of replacementArray" [nzLabel]="i.key" [nzValue]="i.value"></nz-option>
            </nz-select>
          </div>
          <div>
            <small class="d-b text-a-left col-dark">Copy-paste code</small>
            <!-- One-way bound ! -->
            <input type="text" nz-input [ngModel]="replacementSelected" name="replacement" #selectionInput
              (click)="selectionInput.select()" />
          </div>
        </div>
        <div>
          <small class="d-b text-a-right col-dark">Template</small>
          <nz-select nzShowSearch [ngModel]="'Document Missing - Death Certificate'">
            <nz-option nzLabel="Document Missing - Death Certificate" nzValue="Document Missing - Death Certificate">
            </nz-option>
            <nz-option nzLabel="Document Missing - Medical Records" nzValue="Document Missing - Medical Records">
            </nz-option>
          </nz-select>
        </div>
      </div>
      <angular-editor [(ngModel)]="correspondenceRichText"></angular-editor>
    </div>

    <div *ngIf="'sms'==correspType">
      <h4 class="d-b m-t-20">To (Mobile Numbers)</h4>
      <!-- Multi phone nos; ENTER to add new entry -->
      <nz-select nzShowSearch nzMode="tags" style="width: 100%;">
        <nz-option nzLabel="9800560098" nzValue="9800560098"> </nz-option>
      </nz-select>
      <h4 class="d-b m-t-20">Message</h4>
      <textarea nz-input value=""></textarea>
    </div>

  </div>
</ng-container>
</nz-modal>

<!--correspondence  manager-->

<nz-drawer [nzClosable]="true" [nzWidth]="390" [nzPlacement]="'right'" nzTitle="Correspondence"
  [nzVisible]="corresPanelOpen" (nzOnClose)="corresPanel(0)">
  <ng-container *nzDrawerContent>
  <app-correspondence-manager [IO]="policyData" transactionState="corres"></app-correspondence-manager>
  </ng-container>
  <!--  -->
</nz-drawer>


<!-- Notes -->

<nz-drawer [nzClosable]="true" [nzWidth]="390" [nzVisible]="notesPanelOpen" [nzPlacement]="'right'" nzTitle="NOTES"
  (nzOnClose)="notesPanel(0)">
  <ng-container *nzDrawerContent>
  <app-notes-manager [IO]="policyData" transactionState="notes"></app-notes-manager>
  </ng-container>
</nz-drawer>


<!--Worksheet  -->

<!-- <nz-drawer [nzClosable]="true" [nzWidth]="390" [nzVisible]="worksheetPanelOpen" [nzPlacement]="'right'"
  nzTitle="Underwriting Worksheet" (nzOnClose)="worksheetPanel(0)">
  <ng-container *nzDrawerContent>
  <app-claim-worksheet [IO]="policyData" [transactionState]="_state"></app-claim-worksheet>
  </ng-container>
</nz-drawer> -->

<nz-modal [(nzVisible)]="underwritingWorksheetModal" nzTitle="Underwriting Worksheet"
  (nzOnCancel)="underwritingWorksheetModal=false" (nzOnOk)="underwritingWorksheetModal=false" nzOkText="Ok"
  nzWidth="85%" nzZIndex="100">
  <ng-container *nzModalContent>
  <div *ngIf="underwritingWorksheetModal">
    <underwriting-worksheet [IO]="policyData" [transactionState]="_state"></underwriting-worksheet>
  </div>
  </ng-container>
</nz-modal>

<!-- Analyze -->

<nz-modal [(nzVisible)]="analyticsModal" nzTitle="Analyze" (nzOnCancel)="analyticsModal=false"
  (nzOnOk)="analyticsModal=false" nzOkText="Ok" nzWidth="1200px" nzZIndex="100">
  <ng-container *nzModalContent>
  <div *ngIf="analyticsModal">
    <app-ui-analytics-tab [workQueueItem]="getDO(policyData)" [IO]="policyData" [transactionState]="mapperTransactionState" ></app-ui-analytics-tab>
  </div>
  </ng-container>
</nz-modal>

<nz-modal [(nzVisible)]="modalUsrCallVideo" nzTitle="Video Call" [nzFooter]="null" nzClosable
  (nzOnOk)="modalUsrCallVideo=false" (nzOnCancel)="modalUsrCallVideo=false">
  <ng-container *nzModalContent>
  <div class="cust-call-modal">

    <div class="video-call-container">
      <!-- CALL-->
      <div class="flex flex-both-center clickable flex-dir-vert" (click)="videoCall(true)" *ngIf="!videoCallOngoing"
        style="min-height: 350px; background: #f8f8f8">
        <a>
          <i nz-icon nzType="video-camera" nzTheme="outline" style="font-size: 5rem;color: #999" class="d-b p-b-20"></i>
          <b class="f-s-09r">Begin Call</b>
        </a>
      </div>

      <!-- ON CALL -->
      <div *ngIf="videoCallOngoing">
        <video controls autoplay loop width="100%" height="auto" controlsList="nodownload">
          <source [src]="'/assets/images/demo/videocall.webm'" type="video/mp4">
          Your browser does not support the <code>video</code> element.
        </video>
        <div class="flex flex-horiz-space-bw p-t-5">
          <small class="d-b f-s-09r col-red p-t-b-5">
            <i nz-icon [nzType]="'sync'" [spin]="true"></i> Recording ...
          </small>
          <button nz-button nzType="danger">Hangup Call</button>
        </div>
        <!-- <label for="srvcing" class="d-b p-t-b-5">Service Request</label>
        <nz-select nzShowSearch [ngModel]="'#SR6790977'" id="srvcing" class="d-b w-100-pc">
          <nz-option [nzLabel]="'N.A'" [nzValue]="'#0'"></nz-option>
          <nz-option [nzLabel]="'#SR6790977 [Address Change - Pending]'" [nzValue]="'#SR6790977'"></nz-option>
          <nz-option [nzLabel]="'#SR5060992 [Email ID Change - Closed]'" [nzValue]="'#SR5060992'"></nz-option>
          <nz-option [nzLabel]="'#SR2990005 [Date of Birth Change - Closed]'" [nzValue]="'#SR2990005'"></nz-option>
        </nz-select> -->
        <label for="notes-for-video" class="d-b p-t-b-5">Notes</label>
        <textarea nz-input name="" cols="30" rows="4" placeholder="Write your notes ..."
          id="notes-for-video">Customer (Chris) was not available and Rhea (spouse) picked the call. She verified the authenticity of the address change document uploaded (Chris' Passport) by holding it up against the webcam</textarea>
        <div class="flex flex-horiz-space-bw p-t-20">
          <button nz-button nzType="default" (click)="videoCall(false)">Close</button>
          <button nz-button [nzType]="'primary'">Save Note</button>
        </div>
      </div>
    </div>

    <nz-divider nzText="Call Log" nzOrientation="left"></nz-divider>
    <ul class="ul-spaced" (click)="videoCall(true)">
      <li><a><i nz-icon nzType="video" nzTheme="outline"></i> VideoCall-12-apr-2019-10:00am</a> #SR5060992</li>
      <li><a><i nz-icon nzType="video" nzTheme="outline"></i> VideoCall-10-apr-2019-09:00am</a> #SR5060992</li>
      <li><a><i nz-icon nzType="video" nzTheme="outline"></i> VideoCall-21-mar-2019-10:00pm</a> #SR2990005</li>
    </ul>
  </div>
  </ng-container>
</nz-modal>
<nz-modal [(nzVisible)]="modalUsrCall" nzTitle="Audio Call" [nzFooter]="null" nzClosable (nzOnOk)="modalUsrCall=false"
  (nzOnCancel)="modalUsrCall=false">
  <ng-container *nzModalContent>
  <div class="cust-call-modal">
    <img src="/assets/images/demo/audiocall.jpg" alt="" />
    <nz-divider nzText="Call Log" nzOrientation="left"></nz-divider>
    <ul class="ul-spaced">
      <li><a><i nz-icon nzType="audio" nzTheme="outline"></i> AudioCall-12-apr-2019-10:00am</a> #SR5060992</li>
      <li><a><i nz-icon nzType="audio" nzTheme="outline"></i> AudioCall-10-apr-2019-09:00am</a> #SR5060992</li>
      <li><a><i nz-icon nzType="audio" nzTheme="outline"></i> AudioCall-21-mar-2019-10:00pm</a> #SR2990005</li>
    </ul>
  </div>
  </ng-container>
</nz-modal>

<!--Fraud Analytics-->
<nz-modal [(nzVisible)]="fraudAnalyticsModal" nzTitle="Fraud Analytics" (nzOnCancel)="fraudAnalyticsModal = false;" [nzOkText]="null" nzCancelText="Close" nzWidth="90%">
  <ng-container *nzModalContent>
  <app-fraud-rules *ngIf="dataTransformService.barCodeNum" [IO]="policyData" [transactionState]="mapperTransactionState"
          [barcodeNum]='dataTransformService.barCodeNum'>
          </app-fraud-rules>
          <nz-skeleton *ngIf="!dataTransformService.barCodeNum" [nzAvatar]="false" [nzActive]="true"
          [nzLoading]="!dataTransformService.barCodeNum"></nz-skeleton>
          </ng-container>
</nz-modal>

<!--Medical Risk-->
<nz-modal [(nzVisible)]="medicalRiskModal" nzTitle="Medical Risk" (nzOnCancel)="medicalRiskModal = false;" (nzOnOk)="medicalRiskModal = false;" nzWidth="100%">
  <ng-container *nzModalContent>
  <app-medical-risk [IO]="policyData" [transactionState]="_state" [RequirementEntityGuid]="RequirementEntityGuid"></app-medical-risk>
  </ng-container>
</nz-modal>

<!--Similar Cases Underwriting-->
<nz-modal [(nzVisible)]="similarCasesDataModal" nzTitle="Similar Underwriting Decisions" (nzOnCancel)="similarCasesDataModal = false;" [nzOkText]="null" nzCancelText="Close" nzWidth="70vw">
  <ng-container *nzModalContent>
    
    <nz-spin [nzSpinning]="searchSimilarCases" nzTip="Searching for similar cases..." style="min-height: 100px;">
    <nz-table #similarCasesUW nzSize="small" [nzData]="similarUWdecisionList" *ngIf="similarUWdecisionList.length > 0; else noSimilarCasesMsg">
      <thead>
        <tr>
          <th>Policy No</th>
          <th>Decision</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of similarCasesUW.data">
          <td><a (click)="fetchCaseByGuid(data.guid)">{{ data.CASE_NUMBER || '-' }}</a></td>
          <td>{{ data.Underwriter_Decision || '-'  }}</td>
        </tr>
      </tbody>
    </nz-table>
  </nz-spin>

  <ng-template #noSimilarCasesMsg>
    <nz-alert class="m-t-b-15" nzType="info" nzMessage="We didn't find any similar underwriting cases."></nz-alert>
  </ng-template>
  </ng-container>
</nz-modal>

<!--Similar Case Worksheet-->
<nz-modal [(nzVisible)]="showSimilarCaseUWworksheet" nzTitle="Underwriting Worksheet" (nzOnCancel)="showSimilarCaseUWworksheet = false;" [nzOkText]="null" nzCancelText="Close" nzWidth="85%">
  <ng-container *nzModalContent>
    <underwriting-worksheet [IO]="fetchedSimilarCaseDo" [transactionState]="_state"></underwriting-worksheet>
  </ng-container>
</nz-modal>

<!-- risk summarization -->
<nz-modal [(nzVisible)]="riskSummarizationModal" nzTitle="Risk Summarization"
  (nzOnCancel)="riskSummarizationModal=false" (nzOnOk)="riskSummarizationModal=false" [nzOkText]="null" [nzCancelText]="'Close'"
  nzWidth="80%" nzZIndex="100" [nzMaskClosable]="false">
  <ng-container *nzModalContent>
  <div *ngIf="riskSummarizationModal">
    <risk-summarization [IO]="policyData" [transactionState]="_state"></risk-summarization>
  </div>
  </ng-container>
</nz-modal>